import get from 'lodash/fp/get';
import { batch } from 'react-redux';

import UserRole from '@careerstart/wae-common/src/main/constants/user-role';

import {
  creditLoggedInCandidateSkills,
  creditLoggedInCandidateSkillsProcessed,
  emailVerificationOrPWResetUpdateUserData,
  loginProcessed as loginProcessedUpdateApp,
  showSnackbar,
  updateSessionPhoneNumber,
  updateSkillsForSession,
  updateTraining,
  updateTrainingError,
  updateTrainingProcessed,
} from '../main/views/app';
import { ROUTE_CONSTANTS } from '../main/views/app/RouteBuilding/routeConstants';
import {
  dashboardOnboardingEmail,
  dashboardOnboardingEmailError,
  dashboardOnboardingEmailProcessed,
} from '../main/views/dashboard/DashboardOnboarding/dashboardOnboardingReducer';
import {
  createAgency,
  createAgencyError,
  createAgencyProcessed,
  getAgenciesForDashboard,
  getAgenciesForDashboardError,
  getAgenciesForDashboardProcessed,
  getAgencyForAgencyDetail,
  getAgencyForAgencyDetailError,
  getAgencyForAgencyDetailProcessed,
  getCorporationsAgencySupport,
  getCorporationsAgencySupportError,
  getCorporationsAgencySupportProcessed,
  getJobOrdersForDashboard,
  getJobOrdersForDashboardError,
  getJobOrdersForDashboardProcessed,
  getWidgetData,
  getWidgetDataError,
  getWidgetDataProcessed,
  updateAgencyAddress,
  updateAgencyAddressError,
  updateAgencyAddressProcessed,
  updateAgencyIndustries,
  updateAgencyIndustriesError,
  updateAgencyIndustriesProcessed,
} from '../main/views/dashboard/dashboardReducer';
import {
  approveOrRejectEgApplicationErrorV2,
  approveOrRejectEgApplicationProcessedV2,
  approveOrRejectEgApplicationV2,
  approveOrRejectPlacementErrorV2,
  approveOrRejectPlacementProcessedV2,
  approveOrRejectPlacementV2,
  cancelPlacementErrorV2,
  cancelPlacementProcessedV2,
  cancelPlacementV2,
  cancelSeriesJobErrorV2,
  cancelSeriesJobProcessedV2,
  cancelSeriesJobV2,
  cancelSingleJobErrorV2,
  cancelSingleJobProcessedV2,
  cancelSingleJobV2,
  getCancelledPlacementDetail,
  getCancelledPlacementDetailError,
  getCancelledPlacementDetailProcessed,
  getJobOrderDetailErrorV2,
  getJobOrderDetailProcessedV2,
  getJobOrderDetailV2,
  inviteEmployeeErrorV2,
  inviteEmployeeProcessedV2,
  inviteEmployeeV2,
  removeUserFromGroupErrorV2,
  removeUserFromGroupProcessedV2,
  removeUserFromGroupV2,
  revokeJobInvitationsErrorV2,
  revokeJobInvitationsProcessedV2,
  revokeJobInvitationsV2,
  revokeJobOfferErrorV2,
  revokeJobOfferProcessedV2,
  revokeJobOfferV2,
  updateCancelledPlacementErrorV2,
  updateCancelledPlacementProcessedV2,
  updateCancelledPlacementV2,
  updateExtensionGroupErrorV2,
  updateExtensionGroupProcessedV2,
  updateExtensionGroupV2,
  updateGroupOpeningsErrorV2,
  updateGroupOpeningsProcessedV2,
  updateGroupOpeningsV2,
  updateJobRosterEmployeeErrorV2,
  updateJobRosterEmployeeProcessedV2,
  updateJobRosterEmployeeV2,
  updatePlacementDepartmentErrorV2,
  updatePlacementDepartmentProcessedV2,
  updatePlacementDepartmentV2,
  updateShiftOpeningsErrorV2,
  updateShiftOpeningsProcessedV2,
  updateShiftOpeningsV2,
} from '../main/views/jobOrderDetail/jobOrderDetailReducer';
import {
  postBulkDayJob,
  postBulkDayJobError,
  postBulkDayJobProcessed,
  postGroupOrders,
  postGroupOrdersError,
  postGroupOrdersProcessed,
} from '../main/views/jobOrdersCreate/jobCreateReducer';
import {
  getJobOrdersErrorV2,
  getJobOrdersProcessedV2,
  getJobOrdersV2,
  postPlacementApprovalErrorV2,
  postPlacementApprovalProcessedV2,
  postPlacementApprovalV2,
  postPlacementFinalizeErrorV2,
  postPlacementFinalizeProcessedV2,
  postPlacementFinalizeV2,
  postPlacementResolveErrorV2,
  postPlacementResolveProcessedV2,
  postPlacementResolveV2,
  postPlacementUnFinalizeErrorV2,
  postPlacementUnFinalizeProcessedV2,
  postPlacementUnFinalizeV2,
  timecardEditV2ForJobOrderErrorV2,
  timecardEditV2ForJobOrderProcessedV2,
  timecardEditV2ForJobOrderV2,
  updatePlacementCheckInStatusErrorV2,
  updatePlacementCheckInStatusProcessedV2,
  updatePlacementCheckInStatusV2,
} from '../main/views/jobOrdersV2/jobOrdersReducer';
import {
  getPositionTemplateDetail,
  getPositionTemplateDetailError,
  getPositionTemplateDetailProcessed,
} from '../main/views/positionTemplateDetail/positionTemplateDetailReducer';
import {
  getTimecards,
  getTimecardsError,
  getTimecardsProcessed,
  getTimekeepingOverviewData,
  getTimekeepingOverviewDataError,
  getTimekeepingOverviewDataErrorV2,
  getTimekeepingOverviewDataProcessed,
  getTimekeepingOverviewDataProcessedV2,
  getTimekeepingOverviewDataV2,
  postTimeCardUnFinalize,
  postTimeCardUnFinalizeError,
  postTimeCardUnFinalizeProcessed,
  timecardEditV2,
  timecardEditV2Error,
  timecardEditV2Processed,
  updateDisputedTimecard,
  updateDisputedTimecardError,
  updateDisputedTimecardProcessed,
  updateTimekeepingDepartments,
  updateTimekeepingDepartmentsError,
  updateTimekeepingDepartmentsProcessed,
} from '../main/views/timekeeping/timekeepingReducer';
import {
  getFavoriteCorporationList,
  getFavoriteCorporationsListError,
  getFavoriteCorporationsListProcessed,
} from '../main/views/usersList/userDetail/components/UserDetailAccordionCards/Reducers/favoriteCorporationReducer';
import {
  deactivateUser,
  deactivateUserError,
  deactivateUserProcessed,
  getCandidateAttendance,
  getCandidateAttendanceError,
  getCandidateAttendanceProcessed,
  getCertificationsForUsers,
  getCertificationsForUsersError,
  getCertificationsForUsersProcessed,
  getEmployeeDocumentation,
  getEmployeeDocumentationError,
  getEmployeeDocumentationProcessed,
  getOnboardingDocuments,
  getOnboardingDocumentsError,
  getOnboardingDocumentsProcessed,
  getPendingOffers,
  getPendingOffersError,
  getPendingOffersProcessed,
  getPendingWorkerPlacements,
  getPendingWorkerPlacementsError,
  getPendingWorkerPlacementsProcessed,
  getUserDetail,
  getUserDetailError,
  getUserDetailProcessed,
  getUserHistory,
  getUserHistoryError,
  getUserHistoryProcessed,
  getUsers as getUsersV2,
  getUsersError as getUsersErrorV2,
  getUsersProcessed as getUsersProcessedV2,
  getWorkerContracts,
  getWorkerContractsError,
  getWorkerContractsProcessed,
  getWorkerPlacements,
  getWorkerPlacementsError,
  getWorkerPlacementsProcessed,
  postBullhornEmployers,
  postBullhornEmployersError,
  postBullhornEmployersProcessed,
  postCandidateAgencyUpdate,
  postCandidateAgencyUpdateError,
  postCandidateAgencyUpdateProcessed,
  postEmployer,
  postRecrutierAgencyUpdate,
  postRecrutierAgencyUpdateError,
  postRecrutierAgencyUpdateProcessed,
  postUser,
  postUserError,
  postUserProcessed,
  reactivateUser,
  reactivateUserError,
  reactivateUserProcessed,
  setReliabilityExclusion,
  setReliabilityExclusionError,
  setReliabilityExclusionProcessed,
  updateDNA,
  updateDNAError,
  updateDNAProcessed,
  updateDNR,
  updateDNRError,
  updateDNRProcessed,
  updateDocumentsApproved,
  updateDocumentsApprovedError,
  updateDocumentsApprovedProcessed,
  updateEVerify,
  updateEVerifyError,
  updateEVerifyProcessed,
  updateInfraction,
  updateInfractionError,
  updateInfractionProcessed,
  updateUrbanYouthCertified,
  updateUrbanYouthCertifiedError,
  updateUrbanYouthCertifiedProcessed,
  updateUser as updateUserV2,
  updateUserAddress,
  updateUserAddressError,
  updateUserAddressProcessed,
  updateUserError as updateUserErrorV2,
  updateUserName,
  updateUserNameError,
  updateUserNameProcessed,
  updateUserPhoneNumber,
  updateUserPhoneNumberError,
  updateUserPhoneNumberProcessed,
  updateUserProcessed as updateUserProcessedV2,
  updateWotcEligibility,
  updateWotcEligibilityError,
  updateWotcEligibilityProcessed,
} from '../main/views/usersList/usersListReducer';
import {
  getNotifications,
  getNotificationsError,
  getNotificationsProcessed,
  setNotificationsToRead,
  setNotificationsToReadError,
  setNotificationsToReadProcessed,
} from '../main-deprecated/components/NotificationCenter/reducer';
import { navigator } from '../main-deprecated/utils/navigator';
import { fileError, fileProcessed, getFile } from '../main-deprecated/views/app/fileReducer';
import {
  getCandidatesJobs,
  getCandidatesJobsError,
  getCandidatesJobsProcessed,
  getFeaturedJobs,
  getFeaturedJobsError,
  getFeaturedJobsProcessed,
  getIndustryJobs,
  getIndustryJobsError,
  getIndustryJobsProcessed,
  getInterestJobs,
  getInterestJobsError,
  getInterestJobsProcessed,
  getMyTimeThisWeek,
  getMyTimeThisWeekError,
  getMyTimeThisWeekProcessed,
  postPunchForDashboard,
  postPunchForDashboardError,
  postPunchForDashboardProcessed,
} from '../main-deprecated/views/Candidate/dashboard/reducer';
import {
  getInvitedJobOrder,
  getInvitedJobOrderError,
  getInvitedJobOrderProcessed,
  getSkills as getSkillsForJobInvite,
  getSkillsError as getSkillsForJobInviteError,
  getSkillsProcessed as getSkillsForJobInviteProcessed,
  postInviteRespond,
  postInviteRespondError,
  postInviteRespondProcessed,
} from '../main-deprecated/views/Candidate/jobInvitation/reducer';
import {
  cancelPlacementForCandidate,
  cancelPlacementForCandidateError,
  cancelPlacementForCandidateProcessed,
  createPlacementsForCandidate,
  createPlacementsForCandidateError,
  createPlacementsForCandidateProcessed,
  getCandidateDayJobsList,
  getCandidateDayJobsListError,
  getCandidateDayJobsListProcessed,
  getCandidateJobsList,
  getCandidateJobsListError,
  getCandidateJobsListProcessed,
  getCandidateLongJobsList,
  getCandidateLongJobsListError,
  getCandidateLongJobsListProcessed,
  getCandidatePathSelectedJob,
  getCandidatePathSelectedJobError,
  getCandidatePathSelectedJobProcessed,
  getCertificationsForCandidate,
  getCertificationsForCandidateError,
  getCertificationsForCandidateProcessed,
  getCorporationsForCandidate,
  getCorporationsForCandidateError,
  getCorporationsForCandidateProcessed,
  getFilesForCandidate,
  getFilesForCandidateError,
  getFilesForCandidateProcessed,
  getFilteredJobsList,
  getFilteredJobsListError,
  getFilteredJobsListProcessed,
  getGroupsJobOrders,
  getGroupsJobOrdersError,
  getGroupsJobOrdersProcessed,
  getJobOrderForCandidate,
  getJobOrderForCandidateError,
  getJobOrderForCandidateProcessed,
  getPathSelectedPlacementForCandidate,
  getPathSelectedPlacementForCandidateError,
  getPathSelectedPlacementForCandidateProcessed,
  getPlacements,
  getPlacementsError,
  getPlacementsForCandidate,
  getPlacementsForCandidateError,
  getPlacementsForCandidateProcessed,
  getPlacementsProcessed,
  getSkills as getSkillsForJobSignUp,
  getSkillsError as getSkillsForJobSignUpError,
  getSkillsProcessed as getSkillsForJobSignUpProcessed,
  rescindPlacementForCandidate,
  rescindPlacementForCandidateError,
  rescindPlacementForCandidateProcessed,
} from '../main-deprecated/views/Candidate/jobs/reducer';
import {
  getNextShift,
  getNextShiftError,
  getNextShiftProcessed,
  getTimeCards as getEmployeeTimeCards,
  getTimeCardsError as getEmployeeTimeCardsError,
  getTimeCardsProcessed as getEmployeeTimeCardsProcessed,
  postDisputeTimeCard,
  postDisputeTimeCardError,
  postDisputeTimeCardProcessed,
  postPunch as postPunchForTimeTracking,
  postPunchError as postPunchForTimeTrackingError,
  postPunchProcessed as postPunchForTimeTrackingProcessed,
} from '../main-deprecated/views/Candidate/timeTracking';
import {
  createDepartment,
  createDepartmentError,
  createDepartmentProcessed,
  createLocation,
  createLocationError,
  createLocationProcessed,
  deleteDepartment,
  deleteDepartmentError,
  deleteDepartmentProcessed,
  editDepartment,
  editDepartmentError,
  editDepartmentProcessed,
  getCorporationsList,
  getCorporationsListError,
  getCorporationsListProcessed,
  getDepartments,
  getDepartmentsError,
  getDepartmentsProcessed,
  getLocations,
  getLocationsError,
  getLocationsProcessed,
  updateCorpSageId,
  updateCorpSageIdError,
  updateCorpSageIdProcessed,
} from '../main-deprecated/views/corporations/corporationList';
import {
  postCorporation,
  postCorporationBHDecoupled,
  postCorporationError,
  postCorporationProcessed,
} from '../main-deprecated/views/corporations/createCorporation';
import {
  postForgotPassword,
  postForgotPasswordError,
  postForgotPasswordProcessed,
} from '../main-deprecated/views/forgotMyPassword';
import {
  getCorporations as getCorporationsForJobsOrder,
  getCorporationsError as getCorporationsForJobsOrderError,
  getCorporationsProcessed as getCorporationsProcessedForJobsOrder,
  getPositionTemplate as getPositionTemplateForJobsOrder,
  getPositionTemplateErrorForJobs as getPositionTemplateErrorForJobsOrder,
  getPositionTemplateProcessedForJobs as getPositionTemplateProcessedForJobsOrder,
  postJobs,
  postJobsError,
  postJobsProcessed,
} from '../main-deprecated/views/jobs/createJobs';
import {
  cancelShiftGroup,
  cancelShiftGroupError,
  cancelShiftGroupProcessed,
  getCorporationsForJobsList,
  getCorporationsForJobsListError,
  getCorporationsForJobsListProcessed,
  getGroupOrders,
  getGroupOrdersError,
  getGroupOrdersProcessed,
  getJobRoster,
  getJobRosterError,
  getJobRosterProcessed,
  getPathSelectedJob,
  getPathSelectedJobError,
  getPathSelectedJobProcessed,
  getPositionTemplate as getPositionTemplateForJobsList,
  getPositionTemplateError as getPositionTemplateErrorForJobsList,
  getPositionTemplateProcessed as getPositionTemplateProcessedForJobsList,
  getShiftGroupCancelledCount,
  getShiftGroupCancelledCountError,
  getShiftGroupCancelledCountProcessed,
  getShiftGroupList,
  getShiftGroupListError,
  getShiftGroupListProcessed,
  postTimecardApprove as postTimecardApproveForJobList,
  postTimecardApproveError as postTimecardApproveForJobListError,
  postTimecardApproveProcessed as postTimecardApproveForJobListProcessed,
  setIsCreateJobsDialogOpen,
  updateCancelledPlacement as updateCancelledPlacementDeprecated,
  updateCancelledPlacementError as updateCancelledPlacementErrorDeprecated,
  updateCancelledPlacementProcessed as updateCancelledPlacementProcessedDeprecated,
  updatePlacementCheckIn,
  updatePlacementCheckInError,
  updatePlacementCheckInProcessed,
} from '../main-deprecated/views/jobs/jobList';
import {
  login as loginUpdateLogin,
  loginError,
  loginProcessed,
} from '../main-deprecated/views/login';
import {
  updatePassword,
  updatePasswordError,
  updatePasswordProcessed,
} from '../main-deprecated/views/passwordUpdate';
import {
  disableSendVerificationEmailButton,
  passwordReset,
  passwordResetError,
  passwordResetProcessed,
  reqVerifyAccount,
  verifyAccount,
  verifyAccountError,
  verifyAccountProcessed,
} from '../main-deprecated/views/PasswordVerificationOrReset';
import {
  postPositionTemplate,
  postPositionTemplateError,
  postPositionTemplateProcessed,
  postPositionTemplateV2,
  postPositionTemplateV2Error,
  postPositionTemplateV2Processed,
} from '../main-deprecated/views/positionTemplate/createPositionTemplateDrawer';
import {
  deletePositionTemplate,
  deletePositionTemplateError,
  deletePositionTemplateProcessed,
  getCertificationsForPositionTemplateList,
  getCertificationsForPositionTemplateListError,
  getCertificationsForPositionTemplateListProcessed,
  getCorporationsForPositionTemplateList,
  getCorporationsForPositionTemplateListError,
  getCorporationsForPositionTemplateListProcessed,
  getLocationsForPositionTemplateList,
  getLocationsForPositionTemplateListError,
  getLocationsForPositionTemplateListProcessed,
  getPositionTemplateList,
  getPositionTemplateListError,
  getPositionTemplateListProcessed,
  updatePositionTemplate,
  updatePositionTemplateError,
  updatePositionTemplateProcessed,
} from '../main-deprecated/views/positionTemplate/positionTemplateList';
import {
  registerCandidate,
  registerCandidateError,
  registerCandidateProcessed,
  registerEmployer,
  registerEmployerError,
  registerEmployerProcessed,
} from '../main-deprecated/views/register/reducer';
import {
  getDnas,
  getDnasError,
  getDnasProcessed,
  getDnrs,
  getDnrsError,
  getDnrsProcessed,
  getDoNotReturnBreakdown,
  getDoNotReturnBreakdownError,
  getDoNotReturnBreakdownProcessed,
  getEmployeeRetention,
  getEmployeeRetentionError,
  getEmployeeRetentionProcessed,
  getEmployeesHired,
  getEmployeesHiredError,
  getEmployeesHiredProcessed,
  getFillRatio,
  getFillRatioError,
  getFillRatioProcessed,
  getJobOrderRevenue,
  getJobOrderRevenueError,
  getJobOrderRevenueProcessed,
  getJobsCompleted,
  getJobsCompletedError,
  getJobsCompletedProcessed,
  getJobsEntered,
  getJobsEnteredError,
  getJobsEnteredProcessed,
  getOverallAttendance,
  getOverallAttendanceError,
  getOverallAttendanceProcessed,
  getTimeBasedJobOrderNumbers,
  getTimeBasedJobOrderNumbersError,
  getTimeBasedJobOrderNumbersProcessed,
  getUserCountByRole,
  getUserCountByRoleError,
  getUserCountByRoleProcessed,
} from '../main-deprecated/views/reporting/reducer';
import {
  getCertificationsForSettings,
  getCertificationsForSettingsError,
  getCertificationsForSettingsProcessed,
  getUserInfo,
  getUserInfoError,
  getUserInfoProcessed,
  updateSkillsForSettings,
  updateSkillsForSettingsError,
  updateSkillsForSettingsProcessed,
} from '../main-deprecated/views/settings';
import {
  updateUser,
  updateUserError,
  updateUserProcessed,
} from '../main-deprecated/views/settings/reducer';
import {
  deleteCert,
  deleteCertError,
  deleteCertProcessed,
  deleteSkill,
  deleteSkillError,
  deleteSkillProcessed,
  getCerts,
  getCertsError,
  getCertsProcessed,
  getSkills,
  getSkillsError,
  getSkillsProcessed,
  sendNewCertToBackend,
  sendNewCertToBackendError,
  sendNewCertToBackendProcessed,
  sendNewSkillToBackend,
  sendNewSkillToBackendError,
  sendNewSkillToBackendProcessed,
} from '../main-deprecated/views/skillsAndCerts';

import { dispatchErrors } from './errorUtils';

const standardErrorHandler = (payload, dispatch) => {
  dispatchErrors({ dispatch, responsePayload: payload });
};

const API = [
  {
    http: 'post',
    path: 'users/login',
    type: loginUpdateLogin.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(loginProcessedUpdateApp(payload));
        dispatch(loginProcessed(payload));
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({ dispatch, errorHandler: loginError, responsePayload: payload });
    },
  },
  {
    http: 'patch',
    path: 'users/training',
    type: updateTraining.type,
    successCallback: (payload, dispatch) => {
      dispatch(updateTrainingProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: updateTrainingError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'skills/credit-candidates',
    type: creditLoggedInCandidateSkills.type,
    successCallback: (payload, dispatch) => {
      dispatch(creditLoggedInCandidateSkillsProcessed(payload));
    },
    errorCallback: standardErrorHandler,
  },

  {
    http: 'post',
    path: 'users/register-candidate',
    type: registerCandidate.type,
    successCallback: (payload, dispatch) => {
      navigator('/');
      const registerAction = registerCandidateProcessed(payload);
      const message = 'Verify email address to continue; verification email has been sent.';
      const messageAction = showSnackbar({ message });
      batch(() => {
        dispatch(registerAction);
        dispatch(messageAction);
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({ dispatch, errorHandler: registerCandidateError, responsePayload: payload });
    },
  },
  {
    http: 'post',
    path: 'users/register-employer',
    type: registerEmployer.type,
    successCallback: (payload, dispatch) => {
      navigator('/');
      const registerAction = registerEmployerProcessed(payload);
      const message = 'Verify email address to continue; verification email has been sent.';
      const messageAction = showSnackbar({ message });
      batch(() => {
        dispatch(registerAction);
        dispatch(messageAction);
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({ dispatch, errorHandler: registerEmployerError, responsePayload: payload });
    },
  },

  {
    http: 'post',
    path: 'users/summary',
    type: getUserHistory.type,
    successCallback: (payload, dispatch) => {
      dispatch(getUserHistoryProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({ dispatch, errorHandler: getUserHistoryError, responsePayload: payload });
    },
  },

  {
    http: 'patch',
    path: 'password',
    type: updatePassword.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        navigator('dashboard');
        dispatch(updatePasswordProcessed(payload));
        dispatch(showSnackbar({ message: 'Password update successful!' }));
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: updatePasswordError,
        responsePayload: payload,
        customMessage: get(['data', 'errors', 'newPassword'], payload) || 'error.password.update',
      });
    },
  },
  // TODO:Update Function on Corporation DNR/Favorite Tab
  // {
  //   http: 'patch',
  //   path: 'corporations',
  //   type: updateFavoriteDnr.type,
  //   successCallback: (payload, dispatch) => {
  //     batch(() => {
  //       // dispatch(updateFavoriteDnr(payload));
  //     });
  //   },
  //   errorCallback: (payload, dispatch) => {
  //     const errors = get(['data', 'errors'], payload);
  //     // dispatch(updateFavoriteDnr(errors));
  //
  //     const globalError = get(['data', 'errors', 'GLOBAL'], payload);
  //     globalError &&
  //       globalError.messageKey &&
  //       dispatch(showSnackbar({ message: message || globalError.messageKey }));
  //   },
  // },

  {
    http: 'post', // Create Job Order
    path: 'job-orders/batch',
    type: postJobs.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(postJobsProcessed(payload));
        dispatch(showSnackbar({ message: 'Job Post Successful!' }));
        dispatch(setIsCreateJobsDialogOpen(false));
        navigator(ROUTE_CONSTANTS.JOB_ORDERS);
      });
    },
    errorCallback: (payload, dispatch) => {
      const localErrors = get(['data', 'errors'], payload);
      const startErrorKey = Object.keys(localErrors).find((k) => k.endsWith('start'));
      dispatchErrors({
        dispatch,
        errorHandler: postJobsError,
        customMessage: !!startErrorKey && localErrors[startErrorKey],
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post', // Get Dashboard Widget Data
    path: 'views/dashboard',
    type: getWidgetData.type,
    successCallback: (payload, dispatch) => {
      dispatch(getWidgetDataProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({ dispatch, errorHandler: getWidgetDataError, responsePayload: payload });
    },
  },
  {
    http: 'post',
    path: 'send-onboarding-link',
    type: dashboardOnboardingEmail.type,
    successCallback: (payload, dispatch) => {
      dispatch(dashboardOnboardingEmailProcessed(payload));
      dispatch(showSnackbar({ message: 'dashboard.onboarding.submissionsSuccess' }));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: dashboardOnboardingEmailError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post', // Get Dashboard Job Orders
    path: 'job-orders/read',
    type: getJobOrdersForDashboard.type,
    successCallback: (payload, dispatch) => {
      dispatch(getJobOrdersForDashboardProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getJobOrdersForDashboardError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post', // Get Dashboard Agencies
    path: 'agency/read',
    type: getAgenciesForDashboard.type,
    successCallback: (payload, dispatch) => {
      dispatch(getAgenciesForDashboardProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getAgenciesForDashboardError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post', // Get Agency Detail
    path: 'agency/read',
    type: getAgencyForAgencyDetail.type,
    successCallback: (payload, dispatch) => {
      dispatch(getAgencyForAgencyDetailProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getAgencyForAgencyDetailError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post', // Get List of Job Order (V2)
    path: 'v2/job-orders/read',
    type: getJobOrdersV2.type,
    successCallback: (payload, dispatch) => {
      dispatch(getJobOrdersProcessedV2(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({ dispatch, errorHandler: getJobOrdersErrorV2, responsePayload: payload });
    },
  },

  {
    http: 'post', // Get List of Users
    path: 'v2/users/read',
    type: getUsersV2.type,
    successCallback: (payload, dispatch) => {
      dispatch(getUsersProcessedV2(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({ dispatch, errorHandler: getUsersErrorV2, responsePayload: payload });
    },
  },

  {
    http: 'post', // Get user detail
    path: 'v2/users/read',
    type: getUserDetail.type,
    successCallback: (payload, dispatch) => {
      dispatch(getUserDetailProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({ dispatch, errorHandler: getUserDetailError, responsePayload: payload });
    },
  },

  {
    http: 'post', // Get worker placements
    path: 'v2/placements/read',
    type: getWorkerPlacements.type,
    successCallback: (payload, dispatch) => {
      dispatch(getWorkerPlacementsProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getWorkerPlacementsError,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'post', // Get pending worker placements
    path: 'v2/placements/read',
    type: getPendingWorkerPlacements.type,
    successCallback: (payload, dispatch) => {
      dispatch(getPendingWorkerPlacementsProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getPendingWorkerPlacementsError,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'post', // Get pending offers
    path: 'job-orders/extension-group/read',
    type: getPendingOffers.type,
    successCallback: (payload, dispatch) => {
      dispatch(getPendingOffersProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getPendingOffersError,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'post', // Get worker contracts
    path: 'worker-contracts/read',
    type: getWorkerContracts.type,
    successCallback: (payload, dispatch) => {
      dispatch(getWorkerContractsProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getWorkerContractsError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'documents/read',
    type: getEmployeeDocumentation.type,
    successCallback: (payload, dispatch) => {
      dispatch(getEmployeeDocumentationProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getEmployeeDocumentationError,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'post',
    path: 'documents/read-onboarding-docs',
    type: getOnboardingDocuments.type,
    successCallback: (payload, dispatch) => {
      dispatch(getOnboardingDocumentsProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getOnboardingDocumentsError,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'post', // Gets Detail of Job Order (V2)
    path: 'views/job-orders/details/read',
    type: getJobOrderDetailV2.type,
    successCallback: (payload, dispatch) => {
      dispatch(getJobOrderDetailProcessedV2(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getJobOrderDetailErrorV2,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'patch', // update extensionGroup (V2)
    path: 'job-orders/extension-group',
    type: updateExtensionGroupV2.type,
    successCallback: (payload, dispatch) => {
      dispatch(updateExtensionGroupProcessedV2(payload));
      dispatch(showSnackbar({ message: 'jobDetails.extensionUpdate.success' }));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: updateExtensionGroupErrorV2,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'patch',
    path: 'job-orders/extension-group/openings',
    type: updateGroupOpeningsV2.type,
    successCallback: (payload, dispatch) => {
      dispatch(updateGroupOpeningsProcessedV2(payload));
      dispatch(showSnackbar({ message: 'jobDetails.extensionUpdate.success' }));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: updateGroupOpeningsErrorV2,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'job-orders/read',
    type: getPathSelectedJob.type,
    successCallback: (payload, dispatch) => {
      dispatch(getPathSelectedJobProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({ dispatch, errorHandler: getPathSelectedJobError, responsePayload: payload });
    },
  },

  {
    http: 'post',
    path: 'job-orders/groups/shift/read',
    type: getGroupOrders.type,
    successCallback: (payload, dispatch) => {
      dispatch(getGroupOrdersProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({ dispatch, errorHandler: getGroupOrdersError, responsePayload: payload });
    },
  },
  {
    http: 'post',
    path: 'job-orders/read',
    type: getShiftGroupList.type,
    successCallback: (payload, dispatch) => {
      dispatch(getShiftGroupListProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({ dispatch, errorHandler: getShiftGroupListError, responsePayload: payload });
    },
  },
  {
    http: 'post',
    path: 'job-orders/read',
    type: getShiftGroupCancelledCount.type,
    successCallback: (payload, dispatch) => {
      dispatch(getShiftGroupCancelledCountProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getShiftGroupCancelledCountError,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'post', // post create-job
    path: 'v2/create-job-order',
    type: postGroupOrders.type,
    successCallback: (payload, dispatch) => {
      dispatch(postGroupOrdersProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({ dispatch, errorHandler: postGroupOrdersError, responsePayload: payload });
    },
  },
  {
    http: 'post', // post bulk day job
    path: 'job-orders/create-day-job',
    type: postBulkDayJob.type,
    successCallback: (payload, dispatch) => {
      dispatch(postBulkDayJobProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({ dispatch, errorHandler: postBulkDayJobError, responsePayload: payload });
    },
  },
  {
    http: 'post', // Get invited job
    path: 'job-orders/read',
    type: getInvitedJobOrder.type,
    successCallback: (payload, dispatch) => {
      dispatch(getInvitedJobOrderProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({ dispatch, errorHandler: getInvitedJobOrderError, responsePayload: payload });
    },
  },
  {
    http: 'post', // Get a single Position Template for the detail page
    path: 'v2/position-templates/read',
    type: getPositionTemplateDetail.type,
    successCallback: (payload, dispatch) => {
      dispatch(getPositionTemplateDetailProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getPositionTemplateDetailError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post', // Get List of Position Templates
    path: 'position-templates/read',
    type: getPositionTemplateList.type,
    successCallback: (payload, dispatch) => {
      dispatch(getPositionTemplateListProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getPositionTemplateListError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post', // Get palcements
    path: 'placements/read',
    type: getPlacementsForCandidate.type,
    successCallback: (payload, dispatch) => {
      dispatch(getPlacementsForCandidateProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getPlacementsForCandidateError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post', // Get myJobs list for candidate
    path: 'placements/read',
    type: getPathSelectedPlacementForCandidate.type,
    successCallback: (payload, dispatch) => {
      dispatch(getPathSelectedPlacementForCandidateProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getPathSelectedPlacementForCandidateError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'v2/placements/read',
    type: getCancelledPlacementDetail.type,
    successCallback: (payload, dispatch) => {
      dispatch(getCancelledPlacementDetailProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getCancelledPlacementDetailError,
        responsePayload: payload,
      });
    },
  },
  /*
  The code below sends a verification email to a user and handles success and error callbacks.

  On success:
  - The email verification process is considered as processed.
  - A snackbar is shown with the message 'Verification email sent'.
  - The 'Send Verification Email' button is temporarily disabled for 5 minutes

  On error:
  - Verification email request error is dispatched.
  - A snackbar is shown with an error message based on the error type.
  - The 'Send Verification Email' button may be temporarily disabled based on the errors.

  The requestCodeBlock object is defined as follows:
*/
  {
    http: 'post', // Send verification email to user using HTTP POST method
    path: 'users/request-verification', // API endpoint
    type: reqVerifyAccount.type,
    successCallback: (payload, dispatch) => {
      // On a successful verification email request
      batch(() => {
        dispatch(verifyAccountProcessed(payload)); // Dispatch account verification processed
        dispatch(showSnackbar({ message: 'Verification email sent' })); // Show snackbar message
        dispatch(disableSendVerificationEmailButton(true));
      });
      setTimeout(() => {
        dispatch(disableSendVerificationEmailButton(false));
      }, 300000);
    },
    errorCallback: (payload, dispatch) => {
      const diffTime =
        get(['data', 'errors', 'verificationResendPreventedUntil'], payload) - Date.now();
      dispatchErrors({
        dispatch,
        errorHandler: verifyAccountError,
        responsePayload: payload,
      });
      setTimeout(() => {
        dispatch(disableSendVerificationEmailButton(false));
      }, diffTime);
    },
  },

  {
    http: 'get', // Get singular Job Order for Employee
    path: 'job-orders',
    type: getJobOrderForCandidate.type,
    successCallback: (payload, dispatch) => {
      dispatch(getJobOrderForCandidateProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getJobOrderForCandidateError,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'patch',
    path: 'job-orders/cancel',
    type: cancelSingleJobV2.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(cancelSingleJobProcessedV2(payload));
        dispatch(showSnackbar({ message: 'jobDetails.cancelSuccess' }));
        navigator(`/${ROUTE_CONSTANTS.JOB_ORDERS}`);
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({ dispatch, errorHandler: cancelSingleJobErrorV2, responsePayload: payload });
    },
  },
  {
    http: 'patch',
    path: 'job-orders/extension-group/cancel-group',
    type: cancelSeriesJobV2.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(cancelSeriesJobProcessedV2(payload));
        dispatch(showSnackbar({ message: 'jobDetails.cancelSuccess' }));
        navigator(`/${ROUTE_CONSTANTS.JOB_ORDERS}`);
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({ dispatch, errorHandler: cancelSeriesJobErrorV2, responsePayload: payload });
    },
  },
  {
    http: 'patch',
    path: 'job-orders/groups/shift/cancel',
    type: cancelShiftGroup.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(cancelShiftGroupProcessed(payload));
        dispatch(showSnackbar({ message: 'Cancel Job Successful!' }));
      });
    },
    errorCallback: (payload, dispatch) => {
      // FIXME: HB-114 need better error messages
      dispatchErrors({ dispatch, errorHandler: cancelShiftGroupError, responsePayload: payload });
    },
  },

  {
    http: 'patch',
    path: 'job-orders/openings',
    type: updateShiftOpeningsV2.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(updateShiftOpeningsProcessedV2(payload));
        dispatch(showSnackbar({ message: 'jobDetails.extensionUpdate.success' }));
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: updateShiftOpeningsErrorV2,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'patch',
    path: 'users',
    type: updateUser.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(updateUserProcessed(payload));
        dispatch(showSnackbar({ message: 'User update successful!' }));
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({ dispatch, errorHandler: updateUserError, responsePayload: payload });
    },
  },
  {
    http: 'post',
    path: 'users/documents-approved',
    type: updateDocumentsApproved.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(updateDocumentsApprovedProcessed(payload));
        dispatch(showSnackbar({ message: 'User update successful!' }));
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: updateDocumentsApprovedError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'users/everify',
    type: updateEVerify.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(updateEVerifyProcessed(payload));
        dispatch(showSnackbar({ message: 'userDetail.updateUser.success' }));
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: updateEVerifyError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'users/update-urban-youth-certified',
    type: updateUrbanYouthCertified.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(updateUrbanYouthCertifiedProcessed(payload));
        dispatch(showSnackbar({ message: 'userDetail.updateUser.success' }));
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: updateUrbanYouthCertifiedError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'users/update-wotc-eligibility',
    type: updateWotcEligibility.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(updateWotcEligibilityProcessed(payload));
        dispatch(showSnackbar({ message: 'userDetail.updateUser.success' }));
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: updateWotcEligibilityError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'users/update/name',
    type: updateUserName.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(updateUserNameProcessed(payload));
        dispatch(showSnackbar({ message: 'userCard.name.update.success' }));
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: updateUserNameError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'users/set-phone-number',
    type: updateUserPhoneNumber.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(updateUserPhoneNumberProcessed(payload));
        dispatch(updateSessionPhoneNumber(payload?.data));
        dispatch(showSnackbar({ message: 'userCard.phone.update.success' }));
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: updateUserPhoneNumberError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'users/set-address',
    type: updateUserAddress.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(updateUserAddressProcessed(payload));
        dispatch(showSnackbar({ message: 'userCard.address.update.success' }));
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: updateUserAddressError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'users/deactivate',
    type: deactivateUser.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(deactivateUserProcessed(payload));
        dispatch(showSnackbar({ message: 'success.user.deactivate' }));
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({ dispatch, errorHandler: deactivateUserError, responsePayload: payload });
    },
  },
  {
    http: 'post',
    path: 'users/reactivate',
    type: reactivateUser.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(reactivateUserProcessed(payload));
        dispatch(showSnackbar({ message: 'success.user.reactivate' }));
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({ dispatch, errorHandler: reactivateUserError, responsePayload: payload });
    },
  },

  {
    http: 'get',
    path: 'corporations',
    type: getCorporationsForJobsList.type,
    successCallback: (payload, dispatch) => {
      dispatch(getCorporationsForJobsListProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getCorporationsForJobsListError,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'post',
    path: 'position-templates',
    type: postPositionTemplate.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(postPositionTemplateProcessed(payload));
        dispatch(showSnackbar({ message: 'success.position.template.post' }));
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: postPositionTemplateError,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'post',
    path: 'v2/position-templates',
    type: postPositionTemplateV2.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(postPositionTemplateV2Processed(payload));
        dispatch(showSnackbar({ message: 'success.position.template.post' }));
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: postPositionTemplateV2Error,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'get',
    path: 'position-templates',
    type: getPositionTemplateForJobsList.type,
    successCallback: (payload, dispatch) => {
      dispatch(getPositionTemplateProcessedForJobsList(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getPositionTemplateErrorForJobsList,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'get',
    path: 'corporations',
    type: getCorporationsForJobsOrder.type,
    successCallback: (payload, dispatch) => {
      dispatch(getCorporationsProcessedForJobsOrder(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getCorporationsForJobsOrderError,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'post',
    path: 'corporations',
    type: getCorporationsForCandidate.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(getCorporationsForCandidateProcessed(payload));
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getCorporationsForCandidateError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'notifications/read',
    type: getNotifications.type,
    successCallback: (payload, dispatch) => {
      dispatch(getNotificationsProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getNotificationsError,
        responsePayload: payload,
        customMessage: 'error.read.notifications',
      });
    },
  },
  {
    http: 'patch',
    path: 'notifications/mark-read',
    type: setNotificationsToRead.type,
    successCallback: (payload, dispatch) => {
      dispatch(setNotificationsToReadProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: setNotificationsToReadError,
        responsePayload: payload,
        customMessage: 'error.markRead.notifications',
      });
    },
  },
  {
    http: 'post',
    path: 'corporations/read',
    type: getCorporationsList.type,
    successCallback: (payload, dispatch) => {
      dispatch(getCorporationsListProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getCorporationsListError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'corporations/read',
    type: getFavoriteCorporationList.type,
    successCallback: (payload, dispatch) => {
      dispatch(getFavoriteCorporationsListProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getFavoriteCorporationsListError,
        responsePayload: payload,
      });
    },
  },

  {
    axiosOptions: {
      responseType: 'blob',
    },
    http: 'get',
    path: 'files',
    type: getFilesForCandidate.type,
    successCallback: (payload, dispatch) => {
      dispatch(getFilesForCandidateProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getFilesForCandidateError,
        responsePayload: payload,
      });
    },
  },
  {
    axiosOptions: {
      responseType: 'blob',
    },
    http: 'get',
    path: 'files',
    type: getFile.type,
    successCallback: (payload, dispatch) => {
      dispatch(fileProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: fileError,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'post',
    path: 'position-templates/read',
    type: getPositionTemplateForJobsOrder.type,
    successCallback: (payload, dispatch) => {
      dispatch(getPositionTemplateProcessedForJobsOrder(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getPositionTemplateErrorForJobsOrder,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'delete',
    path: 'position-templates',
    type: deletePositionTemplate.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(deletePositionTemplateProcessed(payload));
        dispatch(showSnackbar({ message: 'success.position.template.delete' }));
        dispatch(getPositionTemplateList());
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: deletePositionTemplateError,
        responsePayload: payload,
        customMessage: 'error.positionTemplate.failDelete',
      });
    },
  },

  {
    http: 'patch',
    path: 'position-templates',
    type: updatePositionTemplate.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(updatePositionTemplateProcessed(payload));
        dispatch(showSnackbar({ message: 'success.position.template.update' }));
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: updatePositionTemplateError,
        responsePayload: payload,
        customMessage: 'error.positionTemplate.failUpdate',
      });
    },
  },

  {
    http: 'get', // Get List of Positions
    path: 'position-templates',
    type: getPositionTemplateList.type,
    successCallback: (payload, dispatch) => {
      dispatch(getPositionTemplateListProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getPositionTemplateListError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'locations/read',
    type: getLocationsForPositionTemplateList.type,
    successCallback: (payload, dispatch) => {
      dispatch(getLocationsForPositionTemplateListProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getLocationsForPositionTemplateListError,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'get',
    path: 'certifications',
    type: getCertificationsForSettings.type,
    successCallback: (payload, dispatch) => {
      dispatch(getCertificationsForSettingsProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getCertificationsForSettingsError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'skills/update-candidates',
    type: updateSkillsForSettings.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(updateSkillsForSettingsProcessed(payload));
        dispatch(updateSkillsForSession(payload));
        dispatch(showSnackbar({ message: 'candidate.skillUpdated.successfully' }));
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: updateSkillsForSettingsError,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'post',
    path: 'users/read',
    type: getUserInfo.type,
    successCallback: (payload, dispatch) => {
      dispatch(getUserInfoProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getUserInfoError,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'get',
    path: 'certifications',
    type: getCertificationsForPositionTemplateList.type,
    successCallback: (payload, dispatch) => {
      dispatch(getCertificationsForPositionTemplateListProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getCertificationsForPositionTemplateListError,
        responsePayload: payload,
      });
    },
  },
  // user list
  {
    http: 'get',
    path: 'certifications',
    type: getCertificationsForUsers.type,
    successCallback: (payload, dispatch) => {
      dispatch(getCertificationsForUsersProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getCertificationsForUsersError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'get',
    path: 'corporations',
    type: getCorporationsForPositionTemplateList.type,
    successCallback: (payload, dispatch) => {
      dispatch(getCorporationsForPositionTemplateListProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getCorporationsForPositionTemplateListError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'corporations/create-corporation',
    type: postCorporationBHDecoupled.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(postCorporationProcessed(payload));

        dispatch(showSnackbar({ message: 'success.corporation.create' }));
        navigator('/corporations/corporationList');
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: postCorporationError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'bullhorn/corporations',
    type: postCorporation.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(postCorporationProcessed(payload));

        dispatch(showSnackbar({ message: 'success.corporation.create' }));
        navigator('/corporations/corporationList');
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: postCorporationError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'users',
    type: postUser.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(postUserProcessed(payload));
        dispatch(showSnackbar({ message: 'User created successfully!' })); // TODO: HB-200 Should not be hardcoded for multiple languages
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: postUserError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'bullhorn/employers',
    type: postBullhornEmployers.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(postBullhornEmployersProcessed(payload));
        dispatch(showSnackbar({ message: 'User created successfully!' })); // TODO: HB-200 Should not be hardcoded for multiple languages
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: postBullhornEmployersError,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'post',
    path: 'users',
    type: postUser.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(postUserProcessed(payload));
        dispatch(showSnackbar({ message: 'User created successfully!' })); // TODO: HB-200 Should not be hardcoded for multiple languages
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: postUserError,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'post',
    path: 'users/employer-create',
    type: postEmployer.type,
    successCallback: (payload, dispatch) => {
      dispatch(postUserProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: postUserError,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'post',
    path: 'users/verify',
    type: verifyAccount.type,
    successCallback: (payload, dispatch) => {
      const snackBarMessage = 'account.verified.successfully';
      batch(() => {
        if (payload?.data?.role === UserRole.CANDIDATE) {
          navigator('/employee-mobile-app-info');
        } else {
          navigator('/dashboard');
          dispatch(emailVerificationOrPWResetUpdateUserData(payload));
        }
        dispatch(verifyAccountProcessed(payload));
        dispatch(showSnackbar({ message: snackBarMessage }));
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: verifyAccountError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'password/reset',
    type: passwordReset.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        navigator('/dashboard');
        dispatch(passwordResetProcessed(payload));
        dispatch(emailVerificationOrPWResetUpdateUserData(payload));
        dispatch(showSnackbar({ message: 'Account Password Reset' }));
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: passwordResetError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'password/request-reset',
    type: postForgotPassword.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        navigator('/');
        dispatch(postForgotPasswordProcessed(payload));
        dispatch(
          showSnackbar({ message: 'Email sent. Please check your email to reset your password.' }) // FIXME: HB-943 Change email to either email or mobile once mobile option is available
        );
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: postForgotPasswordError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post', // Get List of job group template for candidates
    path: 'workable-groups',
    type: getCandidateJobsList.type,
    successCallback: (payload, dispatch) => {
      dispatch(getCandidateJobsListProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getCandidateJobsListError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post', // Get List of job group template for candidates
    path: 'workable-groups',
    type: getCandidatePathSelectedJob.type,
    successCallback: (payload, dispatch) => {
      dispatch(getCandidatePathSelectedJobProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getCandidatePathSelectedJobError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post', // Get filtered List of job group template for candidates
    path: 'workable-groups',
    type: getFilteredJobsList.type,
    successCallback: (payload, dispatch) => {
      dispatch(getFilteredJobsListProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getFilteredJobsListError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'day-jobs',
    type: getCandidateDayJobsList.type,
    successCallback: (payload, dispatch) => {
      dispatch(getCandidateDayJobsListProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getCandidateDayJobsListError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'long-term-jobs',
    type: getCandidateLongJobsList.type,
    successCallback: (payload, dispatch) => {
      dispatch(getCandidateLongJobsListProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getCandidateLongJobsListError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'get',
    path: 'certifications',
    type: getCertificationsForCandidate.type,
    successCallback: (payload, dispatch) => {
      dispatch(getCertificationsForCandidateProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getCertificationsForCandidateError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'placements',
    type: createPlacementsForCandidate.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(showSnackbar({ message: 'Job Scheduled!' }));
        dispatch(createPlacementsForCandidateProcessed(payload));
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: createPlacementsForCandidateError,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'post',
    path: 'placements',
    type: getPlacements.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(getPlacementsProcessed(payload));
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getPlacementsError,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'post',
    path: 'job-orders/read',
    type: getGroupsJobOrders.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(getGroupsJobOrdersProcessed(payload));
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getGroupsJobOrdersError,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'patch',
    path: 'placements/cancel',
    type: cancelPlacementForCandidate.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(cancelPlacementForCandidateProcessed(payload));
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: cancelPlacementForCandidateError,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'post',
    path: 'placement/application/rescind',
    type: rescindPlacementForCandidate.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(rescindPlacementForCandidateProcessed(payload));
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: rescindPlacementForCandidateError,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'post',
    path: 'timecard/punch',
    type: postPunchForDashboard.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        const message = 'success.punch';
        dispatch(showSnackbar({ message }));
        dispatch(postPunchForDashboardProcessed(payload));
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: postPunchForDashboardError,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'post',
    path: 'timecard/punch',
    type: postPunchForTimeTracking.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        const message = 'success.punch';
        dispatch(showSnackbar({ message }));
        dispatch(postPunchForTimeTrackingProcessed(payload));
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: postPunchForTimeTrackingError,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'patch',
    path: 'placements/cancel',
    type: cancelPlacementV2.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        const message = 'jobDetails.placement.cancelled.success';
        dispatch(showSnackbar({ message }));
        dispatch(cancelPlacementProcessedV2(payload));
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: cancelPlacementErrorV2,
        responsePayload: payload,
        customMessage: 'error.placement.cancel',
      });
    },
  },

  {
    http: 'post',
    path: 'job-orders/extension-group/remove-candidate',
    type: removeUserFromGroupV2.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        const message = 'jobDetails.placements.cancelled.success';
        dispatch(showSnackbar({ message }));
        dispatch(removeUserFromGroupProcessedV2(payload));
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: removeUserFromGroupErrorV2,
        responsePayload: payload,
        customMessage: 'error.placement.cancel',
      });
    },
  },

  {
    http: 'post', // Get  Job Placements for Job Order
    path: 'placements/read-for-job-order',
    type: getJobRoster.type,
    successCallback: (payload, dispatch) => {
      dispatch(getJobRosterProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getJobRosterError,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'post', // placements/approve (V2)
    path: 'placements/approve',
    type: approveOrRejectPlacementV2.type,
    successCallback: (payload, dispatch) => {
      dispatch(approveOrRejectPlacementProcessedV2(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: approveOrRejectPlacementErrorV2,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'post', // extension group invite approve (V2)
    path: 'job-orders/extension-group/application/response',
    type: approveOrRejectEgApplicationV2.type,
    successCallback: (payload, dispatch) => {
      dispatch(approveOrRejectEgApplicationProcessedV2(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: approveOrRejectEgApplicationErrorV2,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'post',
    path: 'job-orders/invite/respond',
    type: revokeJobInvitationsV2.type,
    successCallback: (payload, dispatch) => {
      dispatch(revokeJobInvitationsProcessedV2(payload));
      dispatch(showSnackbar({ message: 'success.placement.rejected' }));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: revokeJobInvitationsErrorV2,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'post',
    path: 'job-orders/extension-group/offer/respond',
    type: revokeJobOfferV2.type,
    successCallback: (payload, dispatch) => {
      dispatch(revokeJobOfferProcessedV2(payload));
      dispatch(showSnackbar({ message: 'success.placement.rejected' }));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: revokeJobOfferErrorV2,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'patch', // Update Job Placements for Job Order (V2)
    path: 'placements',
    type: updateJobRosterEmployeeV2.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(updateJobRosterEmployeeProcessedV2(payload));
        dispatch(showSnackbar({ message: 'success.jobRoster.update' }));
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: updateJobRosterEmployeeErrorV2,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post', // Update placement check in or out
    path: 'placement/check-in',
    type: updatePlacementCheckIn.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(updatePlacementCheckInProcessed(payload));
        dispatch(showSnackbar({ message: 'success.placement.check.inOut.update' }));
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: updatePlacementCheckInError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'patch', // Update Cancelled Placement
    path: 'placements',
    type: updateCancelledPlacementDeprecated.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(updateCancelledPlacementProcessedDeprecated(payload));
        dispatch(showSnackbar({ message: 'success.cancelledPlacement.update' }));
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: updateCancelledPlacementErrorDeprecated,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'patch', // Update Cancelled Placement (V2)
    path: 'placements',
    type: updateCancelledPlacementV2.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(updateCancelledPlacementProcessedV2(payload));
        dispatch(showSnackbar({ message: 'success.cancelledPlacement.update' }));
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: updateCancelledPlacementErrorV2,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'patch', // Update DNA
    path: 'users/dna',
    type: updateDNA.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(updateDNAProcessed(payload));
        dispatch(showSnackbar({ message: 'success.dna.update' }));
        // dispatch(getUserHistory(query id));// if we have query id, we can use it to update the user new DNA/NDR data to void refresh
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: updateDNAError,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'patch', // Update DNR
    path: 'corporations/dnr',
    type: updateDNR.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(updateDNRProcessed(payload));
        dispatch(showSnackbar({ message: 'success.dnr.update' }));
        // dispatch(getUserHistory(query id));// if we have query id, we can use it to update the user new DNA/NDR data to void refresh
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: updateDNRError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'timecards/apply-dispute',
    type: updateDisputedTimecard.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(updateDisputedTimecardProcessed(payload));
        dispatch(showSnackbar({ message: 'success.timecard.disputedTimecardUpdate' }));
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: updateDisputedTimecardError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'v2/timecards/read',
    type: getTimecards.type,
    successCallback: (payload, dispatch) => {
      dispatch(getTimecardsProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getTimecardsError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'timecard/view',
    type: getTimekeepingOverviewData.type,
    successCallback: (payload, dispatch) => {
      dispatch(getTimekeepingOverviewDataProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getTimekeepingOverviewDataError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'v2/timecard/view',
    type: getTimekeepingOverviewDataV2.type,
    successCallback: (payload, dispatch) => {
      dispatch(getTimekeepingOverviewDataProcessedV2(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getTimekeepingOverviewDataErrorV2,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'timecards/read',
    type: getEmployeeTimeCards.type,
    successCallback: (payload, dispatch) => {
      dispatch(getEmployeeTimeCardsProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getEmployeeTimeCardsError,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'post',
    path: 'timecard/dispute',
    type: postDisputeTimeCard.type,
    successCallback: (payload, dispatch) => {
      dispatch(postDisputeTimeCardProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: postDisputeTimeCardError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'get-next-engagements',
    type: getNextShift.type,
    successCallback: (payload, dispatch) => {
      dispatch(getNextShiftProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getNextShiftError,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'post',
    path: 'timecards/dept/update',
    type: updateTimekeepingDepartments.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(updateTimekeepingDepartmentsProcessed(payload));
        dispatch(showSnackbar({ message: 'success.timecard.update' }));
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: updateTimekeepingDepartmentsError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'timecards/dept/update',
    type: updatePlacementDepartmentV2.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(updatePlacementDepartmentProcessedV2(payload));
        dispatch(showSnackbar({ message: 'success.placement.department.update', type: 'SUCCESS' }));
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: updatePlacementDepartmentErrorV2,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'v2/timecards/edit',
    type: timecardEditV2.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(timecardEditV2Processed(payload));
        dispatch(showSnackbar({ message: 'success.timecard.update' }));
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: timecardEditV2Error,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'v2/timecards/edit',
    type: timecardEditV2ForJobOrderV2.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(timecardEditV2ForJobOrderProcessedV2(payload));
        dispatch(showSnackbar({ message: 'success.timecard.update' }));
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: timecardEditV2ForJobOrderErrorV2,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'timecard/approve',
    type: postTimecardApproveForJobList.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(postTimecardApproveForJobListProcessed(payload));
        dispatch(showSnackbar({ message: 'success.placement.approve' }));
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: postTimecardApproveForJobListError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'timecard/unfinalize',
    type: postTimeCardUnFinalize.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(postTimeCardUnFinalizeProcessed(payload));
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: postTimeCardUnFinalizeError,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'post',
    path: 'v3/timecards/approve',
    type: postPlacementApprovalV2.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(postPlacementApprovalProcessedV2(payload));
        dispatch(showSnackbar({ message: 'success.placement.approve' }));
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: postPlacementApprovalErrorV2,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'v3/timecards/resolve',
    type: postPlacementResolveV2.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(postPlacementResolveProcessedV2(payload));
        dispatch(showSnackbar({ message: 'success.placement.resolve' }));
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: postPlacementResolveErrorV2,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'v3/timecards/finalize',
    type: postPlacementFinalizeV2.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(postPlacementFinalizeProcessedV2(payload));
        dispatch(showSnackbar({ message: 'success.placement.finalize' }));
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: postPlacementFinalizeErrorV2,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'timecard/unfinalize',
    type: postPlacementUnFinalizeV2.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(postPlacementUnFinalizeProcessedV2(payload));
        dispatch(showSnackbar({ message: 'success.placement.unfinalize' }));
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: postPlacementUnFinalizeErrorV2,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'post',
    path: 'get-next-engagements',
    type: getCandidatesJobs.type,
    successCallback: (payload, dispatch) => {
      dispatch(getCandidatesJobsProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getCandidatesJobsError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post', // Candidate Dashboard
    path: 'workable-groups',
    type: getFeaturedJobs.type,
    successCallback: (payload, dispatch) => {
      dispatch(getFeaturedJobsProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getFeaturedJobsError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'workable-groups',
    type: getIndustryJobs.type,
    successCallback: (payload, dispatch) => {
      dispatch(getIndustryJobsProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getIndustryJobsError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post', // Candidate Dashboard
    path: 'workable-groups',
    type: getInterestJobs.type,
    successCallback: (payload, dispatch) => {
      dispatch(getInterestJobsProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getInterestJobsError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'timecards/read',
    type: getMyTimeThisWeek.type,
    successCallback: (payload, dispatch) => {
      dispatch(getMyTimeThisWeekProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getMyTimeThisWeekError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'skills/read',
    type: getSkills.type,
    successCallback: (payload, dispatch) => {
      dispatch(getSkillsProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getSkillsError,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'post',
    path: 'skills/read',
    type: getSkillsForJobInvite.type,
    successCallback: (payload, dispatch) => {
      dispatch(getSkillsForJobInviteProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getSkillsForJobInviteError,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'post',
    path: 'skills/read',
    type: getSkillsForJobSignUp.type,
    successCallback: (payload, dispatch) => {
      dispatch(getSkillsForJobSignUpProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getSkillsForJobSignUpError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'job-orders/invite/respond',
    type: postInviteRespond.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(showSnackbar({ message: 'success.joborder.invite.respond' }));
        dispatch(postInviteRespondProcessed(payload));
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: postInviteRespondError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'certifications/read',
    type: getCerts.type,
    successCallback: (payload, dispatch) => {
      dispatch(getCertsProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getCertsError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'skills',
    type: sendNewSkillToBackend.type,
    successCallback: (payload, dispatch) => {
      dispatch(sendNewSkillToBackendProcessed(payload));
      dispatch(showSnackbar({ message: 'success.skill.add' }));

      dispatch(getSkills());
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: sendNewSkillToBackendError,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'post',
    path: 'certifications/create',
    type: sendNewCertToBackend.type,
    successCallback: (payload, dispatch) => {
      dispatch(sendNewCertToBackendProcessed(payload));
      dispatch(showSnackbar({ message: 'success.cert.add' }));

      dispatch(
        getCerts({
          filters: [
            {
              field: 'state.status',
              operation: 'equals',
              value: 'active',
            },
          ],
        })
      );
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: sendNewCertToBackendError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'delete',
    path: 'skills',
    type: deleteSkill.type,
    successCallback: (payload, dispatch) => {
      dispatch(getSkills());
      dispatch(deleteSkillProcessed(payload));
      dispatch(showSnackbar({ message: 'delete.skill' }));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: deleteSkillError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'delete',
    path: 'certifications/delete',
    type: deleteCert.type,
    successCallback: (payload, dispatch) => {
      dispatch(
        getCerts({
          filters: [
            {
              field: 'state.status',
              operation: 'equals',
              value: 'active',
            },
          ],
        })
      );
      dispatch(deleteCertProcessed(payload));
      dispatch(showSnackbar({ message: 'delete.cert' }));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: deleteCertError,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'post',
    path: 'metrics/fill-ratio',
    type: getFillRatio.type,
    successCallback: (payload, dispatch) => {
      dispatch(getFillRatioProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getFillRatioError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'metrics/employee-retention',
    type: getEmployeeRetention.type,
    successCallback: (payload, dispatch) => {
      dispatch(getEmployeeRetentionProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getEmployeeRetentionError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'metrics/user-count-by-role',
    type: getUserCountByRole.type,
    successCallback: (payload, dispatch) => {
      dispatch(getUserCountByRoleProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getUserCountByRoleError,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'post',
    path: 'job-orders/read',
    type: getJobsEntered.type,
    successCallback: (payload, dispatch) => {
      dispatch(getJobsEnteredProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getJobsEnteredError,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'post',
    path: 'job-orders/read',
    type: getJobsCompleted.type,
    successCallback: (payload, dispatch) => {
      dispatch(getJobsCompletedProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getJobsCompletedError,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'post',
    path: 'metrics/jobs-entered-by-role-by-date',
    type: getTimeBasedJobOrderNumbers.type,
    successCallback: (payload, dispatch) => {
      dispatch(getTimeBasedJobOrderNumbersProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getTimeBasedJobOrderNumbersError,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'post',
    path: 'metrics/job-orders/revenue',
    type: getJobOrderRevenue.type,
    successCallback: (payload, dispatch) => {
      dispatch(getJobOrderRevenueProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getJobOrderRevenueError,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'post',
    path: 'metrics/employees-hires', // FIXME: Derya check this once endpoint is ready
    type: getEmployeesHired.type,
    successCallback: (payload, dispatch) => {
      dispatch(getEmployeesHiredProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getEmployeesHiredError,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'post',
    path: 'metrics/dnrs', // FIXME: Derya check this once endpoint is ready
    type: getDnrs.type,
    successCallback: (payload, dispatch) => {
      dispatch(getDnrsProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getDnrsError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'metrics/dnas', // FIXME: Derya check this once endpoint is ready
    type: getDnas.type,
    successCallback: (payload, dispatch) => {
      dispatch(getDnasProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getDnasError,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'post',
    path: 'metrics/overall-attendance',
    type: getOverallAttendance.type,
    successCallback: (payload, dispatch) => {
      dispatch(getOverallAttendanceProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getOverallAttendanceError,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'post',
    path: 'metrics/do-not-return-breakdown',
    type: getDoNotReturnBreakdown.type,
    successCallback: (payload, dispatch) => {
      dispatch(getDoNotReturnBreakdownProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getDoNotReturnBreakdownError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'v2/send-offer',
    type: inviteEmployeeV2.type,
    successCallback: (payload, dispatch) => {
      dispatch(showSnackbar({ message: 'success.jobOrder.invite' }));
      dispatch(inviteEmployeeProcessedV2(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: inviteEmployeeErrorV2,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'corporations/departments/delete',
    type: deleteDepartment.type,
    successCallback: (payload, dispatch) => {
      dispatch(showSnackbar({ message: 'success.department.delete' }));
      dispatch(deleteDepartmentProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: deleteDepartmentError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'corporations/departments/read',
    type: getDepartments.type,
    successCallback: (payload, dispatch) => {
      dispatch(getDepartmentsProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getDepartmentsError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'locations/read',
    type: getLocations.type,
    successCallback: (payload, dispatch) => {
      dispatch(getLocationsProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getLocationsError,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'post',
    path: 'corporations/departments',
    type: createDepartment.type,
    successCallback: (payload, dispatch) => {
      dispatch(showSnackbar({ message: 'success.department.created' }));
      dispatch(createDepartmentProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: createDepartmentError,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'post',
    path: 'location/create',
    type: createLocation.type,
    successCallback: (payload, dispatch) => {
      dispatch(showSnackbar({ message: 'location.create.success' }));
      dispatch(createLocationProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: createLocationError,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'post',
    path: 'corporations/update-sage-id',
    type: updateCorpSageId.type,
    successCallback: (payload, dispatch) => {
      dispatch(showSnackbar({ message: 'corporation.updateSageId.success' }));
      dispatch(updateCorpSageIdProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: updateCorpSageIdError,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'patch',
    path: 'corporations/departments',
    type: editDepartment.type,
    successCallback: (payload, dispatch) => {
      dispatch(showSnackbar({ message: 'success.department.update' }));
      dispatch(editDepartmentProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: editDepartmentError,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'post', // Update placement check in or out (V2)
    path: 'placement/check-in',
    type: updatePlacementCheckInStatusV2.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(updatePlacementCheckInStatusProcessedV2(payload));
        dispatch(showSnackbar({ message: 'success.placement.checkIn.update' }));
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: updatePlacementCheckInStatusErrorV2,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'patch',
    path: 'users',
    type: updateUserV2.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(updateUserProcessedV2(payload));
        dispatch(showSnackbar({ message: 'userDetail.updateUser.success' }));
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({ dispatch, errorHandler: updateUserErrorV2, responsePayload: payload });
    },
  },

  {
    http: 'patch',
    path: 'users/set-recruiter-agency',
    type: postRecrutierAgencyUpdate.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(postRecrutierAgencyUpdateProcessed(payload));
        dispatch(showSnackbar({ message: 'userDetail.updateUser.success' }));
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: postRecrutierAgencyUpdateError,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'patch',
    path: 'users/candidate-agency-recruiter',
    type: postCandidateAgencyUpdate.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(postCandidateAgencyUpdateProcessed(payload));
        dispatch(showSnackbar({ message: 'userDetail.updateUser.success' }));
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: postCandidateAgencyUpdateError,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'post',
    path: 'placements/read-by-user-infractions',
    type: getCandidateAttendance.type,
    successCallback: (payload, dispatch) => {
      dispatch(getCandidateAttendanceProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getCandidateAttendanceError,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'patch',
    path: 'placements',
    type: updateInfraction.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(updateInfractionProcessed(payload));
        dispatch(showSnackbar({ message: 'success.attendance.update' }));
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: updateInfractionError,
        customMessage: 'error.attendance.update',
      });
    },
  },
  {
    http: 'post',
    path: 'placements/set-reliability-exclusion',
    type: setReliabilityExclusion.type,
    successCallback: (payload, dispatch) => {
      batch(() => {
        dispatch(setReliabilityExclusionProcessed(payload));
        dispatch(showSnackbar({ message: 'success.placement.reliabilityExclusion' }));
      });
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: setReliabilityExclusionError,
        customMessage: 'error.placement.reliabilityExclusion',
      });
    },
  },
  {
    http: 'post',
    path: 'agency/create',
    type: createAgency.type,
    successCallback: (payload, dispatch) => {
      dispatch(createAgencyProcessed(payload));
      dispatch(showSnackbar({ message: 'dashboard.agency.create.success' }));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: createAgencyError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'agency/address/update',
    type: updateAgencyAddress.type,
    successCallback: (payload, dispatch) => {
      dispatch(updateAgencyAddressProcessed(payload));
      dispatch(showSnackbar({ message: 'dashboard.agency.edit.updateAddressSuccess' }));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: updateAgencyAddressError,
        responsePayload: payload,
      });
    },
  },

  {
    http: 'post',
    path: 'agency/industries/update',
    type: updateAgencyIndustries.type,
    successCallback: (payload, dispatch) => {
      dispatch(updateAgencyIndustriesProcessed(payload));
      dispatch(showSnackbar({ message: 'dashboard.agency.edit.updateIndustriesSuccess' }));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: updateAgencyIndustriesError,
        responsePayload: payload,
      });
    },
  },
  {
    http: 'post',
    path: 'corporations/read-agency-supported',
    type: getCorporationsAgencySupport.type,
    successCallback: (payload, dispatch) => {
      dispatch(getCorporationsAgencySupportProcessed(payload));
    },
    errorCallback: (payload, dispatch) => {
      dispatchErrors({
        dispatch,
        errorHandler: getCorporationsAgencySupportError,
        responsePayload: payload,
      });
    },
  },
];

export default API;
